import React from 'react';
import type { AllergyResponse } from '../../../../../../Types/schema-helpers';
import {
  getSeverityDotColor,
  getCriticalityDotColor,
  getStatusDotColor,
} from '../../../../../../ConfigFiles/colors/allergies_colors';

interface TriforceIndicatorProps {
  status: AllergyResponse['status'];
  criticality: AllergyResponse['criticality'];
  severity: AllergyResponse['severity'];
  size?: number; // Size of individual dots in px (defaults to 6px)
}

export const TriforceIndicator: React.FC<TriforceIndicatorProps> = ({
  status,
  criticality,
  severity,
  size = 6,
}) => {
  const dotStyle = (color: string) => ({
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: color,
  });

  return (
    <div
      className="d-inline-flex flex-column align-items-center justify-content-center ms-1 me-1"
      style={{
        width: `${size * 2.5}px`,
        height: `${size * 2.2}px`,
        gap: '2px',
        lineHeight: 0,
      }}
      title={`Status: ${status} | Criticality: ${criticality} | Severity: ${severity}`}
    >
      {/* Top Dot: Status */}
      <div style={dotStyle(getStatusDotColor(status))} />

      {/* Bottom Row: Criticality (Left) & Severity (Right) */}
      <div className="d-flex align-items-center justify-content-between w-100">
        <div style={dotStyle(getCriticalityDotColor(criticality))} />
        <div style={dotStyle(getSeverityDotColor(severity))} />
      </div>
    </div>
  );
};
